/* @flow */

import * as React from 'react';
import classNames from 'classnames';
import useSheet from 'app/jss';

type Props = {
  classes: Object,
  id: string,
  name: string,
};

function BonusIcon({ classes, id, name }: Props) {
  return (
    <span
      className={classNames(classes.bonus, {
        [classes.captaincy]: id === 'captain',
      })}
    >
      {name}
    </span>
  );
}

function applyStyles(theme: Theme) {
  return {
    bonus: {
      color: 'white',
      display: 'inline-block',
      lineHeight: '1.5em',
      fontSize: '0.8em',
      paddingTop: 1,
      position: 'relative',
      textAlign: 'center',
      width: '1.5em',
    },
    captaincy: {
      backgroundColor: theme.color.blue,
      color: theme.color.white,
      '&:before, &:after': {
        borderBottomColor: 'transparent',
        borderLeftColor: 'transparent',
        borderStyle: 'solid',
        borderLeftWidth: 0,
        content: '"\\00a0"',
        height: 0,
        position: 'absolute',
        top: '100%',
        width: 0,
      },
      '&:before': {
        borderTopColor: theme.color.blue,
        borderRightColor: 'transparent',
        borderTopWidth: '0.4em',
        borderRightWidth: '0.8em',
        borderBottomWidth: 0,
        left: 0,
      },
      '&:after': {
        borderTopColor: 'transparent',
        borderRightColor: theme.color.blue,
        borderTopWidth: 0,
        borderRightWidth: '0.8em',
        borderBottomWidth: '0.4em',
        right: 0,
      },
    },
  };
}

export default useSheet(applyStyles)(BonusIcon);
